/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceBulkActionCandidatesResponse } from './InstanceBulkActionCandidatesResponse';
import {
    InstanceBulkActionCandidatesResponseFromJSON,
    InstanceBulkActionCandidatesResponseFromJSONTyped,
    InstanceBulkActionCandidatesResponseToJSON,
} from './InstanceBulkActionCandidatesResponse';

/**
 * 
 * @export
 * @interface FindInstanceBulkDecisionCandidates200Response
 */
export interface FindInstanceBulkDecisionCandidates200Response {
    /**
     * 
     * @type {InstanceBulkActionCandidatesResponse}
     * @memberof FindInstanceBulkDecisionCandidates200Response
     */
    data?: InstanceBulkActionCandidatesResponse;
}

/**
 * Check if a given object implements the FindInstanceBulkDecisionCandidates200Response interface.
 */
export function instanceOfFindInstanceBulkDecisionCandidates200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindInstanceBulkDecisionCandidates200ResponseFromJSON(json: any): FindInstanceBulkDecisionCandidates200Response {
    return FindInstanceBulkDecisionCandidates200ResponseFromJSONTyped(json, false);
}

export function FindInstanceBulkDecisionCandidates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindInstanceBulkDecisionCandidates200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : InstanceBulkActionCandidatesResponseFromJSON(json['data']),
    };
}

export function FindInstanceBulkDecisionCandidates200ResponseToJSON(value?: FindInstanceBulkDecisionCandidates200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': InstanceBulkActionCandidatesResponseToJSON(value.data),
    };
}

